import { render, staticRenderFns } from "./SiteDetailsScreen.vue?vue&type=template&id=1461c85b&scoped=true"
import script from "./SiteDetailsScreen.vue?vue&type=script&lang=js"
export * from "./SiteDetailsScreen.vue?vue&type=script&lang=js"
import style0 from "./SiteDetailsScreen.vue?vue&type=style&index=0&id=1461c85b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1461c85b",
  null
  
)

export default component.exports